<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-07 09:19:50
 * @LastEditors: luckymiaow
 * @LastEditTime: 2023-08-11 10:38:06
-->

<script lang="ts" setup>
import { Select } from 'ant-design-vue';
import { onMounted, ref, unref, useAttrs, useSlots, watchEffect, withDefaults } from 'vue';
import { get } from 'lodash-es';
import type { ISelectProps, LabeledValue, OptionsItem } from '../types';
import { FieldNames } from '../types';
import useForm, { readOnlySlot } from '../../form/src/useFormConfig';
import OptionVNode, { findLabelByValueForDisplay } from './showOption';

interface Props extends ISelectProps {
  fieldNames?: FieldNames;

  insertOptions?: unknown[]; // 插入选项 以做回显

  selectedFirst?: boolean; // 是否默认选中第一条
}

const props = withDefaults(defineProps<Props>(), {
  labelInValue: false,
  insertOptions: () => [],
  selectedFirst: false,
  filterOption: true,
});
const emit = defineEmits(['select', 'update:value', 'change']);

const isFirstLoad = ref<boolean>(true);

const attrs = useAttrs();

const slots = useSlots();

const { getBindValue } = useForm<ISelectProps>({
  props,
  componentName: 'SelectBasic',
  attrs,
});

const insertOptions = ref([]);

const options_in = ref<OptionsItem<unknown>[]>();

const { selectedNodes } = findLabelByValueForDisplay(attrs, options_in, slots, props);

watchEffect(() => {
  const { label, value, options } = { ...new FieldNames(), ...props.fieldNames };
  options_in.value = undefined;
  let data: any[] = unref(getBindValue).options ?? [];
  if (unref(insertOptions).length > 0) {
    // data = [...insertOptions.value, ...data];
    unref(insertOptions).forEach(item => {
      if (!data.find(i => get(i, value) === get(item, value))) {
        data.unshift(item);
      }
    });
  }

  if (unref(getBindValue)?.value && unref(getBindValue)?.labelInValue === true) {
    const optionValue = unref(getBindValue).value as LabeledValue<unknown[]> | LabeledValue<unknown[]>[];
    if (Array.isArray(optionValue)) {
      const list = optionValue
        .filter(o => !data.map(e => get(e, value)).includes(o.value))
        .map(e => {
          return { value: e.value, label: e.label, data: e.data };
        });
      data = data.concat(list as any);
    } else {
      const index = data.findIndex(e => get(e, value) === optionValue.value);
      if (index === -1 && optionValue.value) {
        const temp = { value: optionValue.value, label: optionValue.label, data: optionValue?.data };
        data.unshift(temp);
      }
    }
  }
  if (data.length > 0) {
    options_in.value = [];
    data.forEach(e => {
      const t: any = {
        disabled: e?.disabled,
        label: get(e, label),
        value: get(e, value),
        data: e,
      };
      if (get(e, options)) {
        t.options = get(e, options)?.map((e: any) => {
          return { label: get(e, label), value: get(e, value), data: e };
        });
      }
      options_in.value?.push(t);
    });
  }
});

watchEffect(() => {
  if (
    props.selectedFirst &&
    isFirstLoad.value &&
    options_in.value &&
    options_in.value.length > 0 &&
    getBindValue.value.value == null
  ) {
    setSelectedFirst(options_in.value);
    isFirstLoad.value = false;
  }
});

function select(value: any, option: any) {
  emit('select', value, option, options_in.value);
}

function change(value: any, option: any) {
  emit('update:value', value);
  emit('change', value, option);
}

function setSelectedFirst(data: any[]) {
  if (data.length > 0) {
    const [first] = data;
    const { value } = { ...new FieldNames(), ...props.fieldNames };
    change(get(first, value), first);
  }
}

function filterOption(input: string, option: any) {
  if (props.filterOption === false) return false;
  const str = (option.label ?? option.value).toString();

  return str?.toLowerCase().includes(input.toLowerCase());
}

onMounted(() => {
  insertOptions.value = props.insertOptions as any;
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <span
    v-if="getBindValue?.readOnly || readOnlySlot in $slots"
    :class="getBindValue?.readOnlyClassName"
    :style="getBindValue?.readOnlyStyle ? getBindValue?.readOnlyStyle : {}"
    ><slot :name="readOnlySlot" :text="getBindValue.value" :selected-nodes="selectedNodes">
      <OptionVNode :selectedNodes="selectedNodes"></OptionVNode>
    </slot>
  </span>
  <Select
    v-else
    v-bind="getBindValue"
    :fieldNames="null as any"
    :options="options_in"
    :filterOption="filterOption"
    @select="select"
    @change="change"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </Select>
</template>
